export default __webpack_public_path__ + "b093bc45aa235d1428433727e630b5e6.jpg";